import type { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

import type { NegociationId } from '@/store/pretrade/api/types.ts';

type Props = {
  id: NegociationId;
  status: 'done' | 'missed';
};

export const NegociationTerminationFeedback = ({ id, status }: Props) => {
  const color = status === 'done' ? 'success' : 'danger';
  return (
    <div className="p-2 d-flex flex-column align-items-center justify-content-center text-center card card-bordered mx-1">
      <div
        className={`d-flex align-items-center justify-content-center bg-${color} bg-opacity-10 rounded-circle`}
        style={{ width: 48, height: 48 }}
      >
        <i className={`icon icon-md text-${color}`}>{status === 'done' ? 'check' : 'warning'} </i>
      </div>

      <span className="mt-2 mb-1 fw-bold">
        <FormattedMessage id="voiceTimestamping.panel.negociation.title" values={{ id }} />
      </span>
      <span>
        <FormattedMessage
          id="voiceTimestamping.panel.negociation.terminated"
          values={{
            isDone: status === 'done',
            // NOSONAR
            b: (children) => <NegociationOutcome status={status}>{children}</NegociationOutcome>,
          }}
        />
      </span>
    </div>
  );
};

type NegociationOutcomeProps = PropsWithChildren<{
  status: 'done' | 'missed';
}>;

const NegociationOutcome = ({ children, status }: NegociationOutcomeProps) => (
  <span className={`fw-bold text-${status === 'done' ? 'success' : 'danger'}`}>{children}</span>
);
